<script setup lang="ts">
defineProps({
	width: {
		type: String,
		default: '24',
	},
	height: {
		type: String,
		default: '24',
	},
});
</script>
<template>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		:width="width"
		:height="height"
		viewBox="0 0 24 24"
		fill="none"
	>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M7.67072 0.164403C7.55491 0.229179 7.47719 0.352169 7.47823 0.491815C7.48012 0.658885 7.59524 0.799877 7.75206 0.845472C7.7674 0.849679 8.26819 0.943225 8.26819 0.943225C8.42208 0.981081 8.52393 1.10037 8.52635 1.26088C8.52755 1.42189 8.41588 1.51981 8.37039 1.54101C6.85249 2.45275 -0.0926392 4.38037 0.000936728 12.8922C0.0540148 17.674 3.42671 22.11 6.64449 23.4052C7.56629 23.7757 8.30748 23.633 8.33109 23.351C8.34385 23.1956 7.96093 22.5581 7.96093 22.5581C6.73255 20.5367 5.50193 17.7519 5.07937 14.0434C4.83535 11.9149 4.27993 5.8517 12.4345 5.79786C16.3455 5.77178 19.8191 8.33454 19.393 13.1165C19.0677 16.7503 16.2587 19.1408 11.8854 19.3942C11.3839 19.4221 10.9447 19.8959 11.1577 20.4969C11.4886 21.4338 12.4707 24.3488 14.5185 23.9655C19.9374 22.7273 24.062 18.5304 23.9993 12.83C23.9105 4.70963 16.5215 -0.0740045 9.35026 0.000866024C7.95007 0.0158401 7.7045 0.14556 7.67072 0.164403Z"
			fill="#D0D5DD"
		/>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M11.0999 15.9043C14.4679 15.6596 15.4851 13.9884 15.6121 12.5953C15.7513 11.061 14.5171 8.9221 12.1861 9.22594C8.84893 9.65984 9.00945 11.9604 9.08482 12.8594C9.14331 13.5579 9.28578 14.1836 9.49069 14.7162C9.71815 15.3047 10.2978 15.9628 11.0999 15.9043Z"
			fill="#D0D5DD"
		/>
	</svg>
</template>
